import { useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import UserContext from 'context/UserSessionContext';
import useApi, { UPDATE_WIDGET_DATE_SETTINGS } from 'hooks/useApi';
import {
  mapWidgetType,
  inheritDashboardProperties,
  updateNavigationDashboardsItem
} from 'utils/widget-helpers';
import { UPDATE_WIDGET } from 'hooks/useFetchCannedDashboard/actions';
import * as DASHBOARD_ACTIONS from 'hooks/useFetchCannedDashboardList/actions';

import request from 'utils/request';

export default ({ widget, updateWidget, dashboardData, dispatchCannedDashboardList }) => {
  const history = useHistory();
  const { id } = useParams();

  const { session } = useContext(UserContext);
  const { portfolios, holdings } = session;

  const [state, makeRequest] = useApi();
  const { data, isLoading, isError } = state;

  const widgetType = widget && widget.overlay.baseWidget.widgetType.name;

  useEffect(() => {
    if (!data || isLoading || isError) {
      return;
    }

    const { id: widgetId, dashboardId } = data;
    const { masterObjectId } = dashboardData;
    const { startDate, endDate, dateMatchType, dateRangeTypeId } = inheritDashboardProperties(
      data,
      dashboardData
    );

    if (dashboardData.isCanned) {
      dispatchCannedDashboardList({
        type: DASHBOARD_ACTIONS.DASHBOARD_UPDATE_LIST_ITEM,
        payload: { currentDashboardId: id, deepCopyDashboardId: dashboardId }
      });

      // This function changes the value of user context property directly without dispatching an action! Keep in mind!
      updateNavigationDashboardsItem({ portfolios, holdings, masterObjectId, id, dashboardId });

      history.push(`/canned/${masterObjectId}/${dashboardId}`);
    } else {
      const widgetDateUpdateProps = {
        startDate,
        endDate,
        dateMatchType,
        dateRangeTypeId
      };

      updateWidget({
        type: UPDATE_WIDGET,
        payload: {
          id: widgetId,
          data: widgetDateUpdateProps
        }
      });
    }
  }, [data, isLoading, isError, updateWidget, dashboardData, history, dispatchCannedDashboardList]); //eslint-disable-line

  const onDateSettingsSubmit = formData => {
    const dateData = {
      startDate: widget.startDate,
      endDate: widget.endDate,
      dateRangeTypeId: widget.dateRangeTypeId,
      dateMatchType: widget.dateMatchType
    };
    const {
      masterObjectId: dashboardMasterObjectId,
      masterObjectTypeId: dashboardMasterObjectTypeId,
      objectTypeDetailId: dashboardObjectTypeDetailId
    } = dashboardData;

    const updateData = {
      id: widget.id,
      widgetType: mapWidgetType(widgetType),

      customDateRangeMatchType: widget.customDateMatchType,
      dashboardMasterObjectId,
      dashboardMasterObjectTypeId,
      dashboardObjectTypeDetailId,
      ...dateData,
      ...formData
    };

    // Approach 3 with axios request directly
    const reqParams = UPDATE_WIDGET_DATE_SETTINGS({ ...updateData });
    return request(reqParams);

    // Comments are left due to uncertainty about approach 1 and 2 not working - WIP

    // Original approach
    // makeRequest(UPDATE_WIDGET_DATE_SETTINGS({ ...updateData }))

    // Approach 1 with data
    // if (data) {
    //   return data;
    // }

    // Approach 2 with Promise
    // return new Promise(() => {
    //   makeRequest(UPDATE_WIDGET_DATE_SETTINGS({ ...updateData }));
    // })
  };

  return [onDateSettingsSubmit];
};
